import { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '../components/layout/Header';
import { NavigationItem } from '../types/navigation';

interface MainLayoutProps {
  navigation: NavigationItem[];
}

export function MainLayout({ navigation }: MainLayoutProps) {
  return (
    <div className="min-h-screen bg-neutral-50 text-neutral-900 dark:bg-neutral-950 dark:text-neutral-100">
      <Header navigation={navigation} />
      <main>
        <div className="mx-auto max-w-[1600px] px-4 py-6 sm:px-6 lg:px-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export function LayoutContent({ children }: { children?: ReactNode }) {
  return <div className="mx-auto max-w-[1600px] px-4 py-6 sm:px-6 lg:px-8">{children}</div>;
}
